import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import { Subscription, timer } from 'rxjs';

@Component({

  selector: 'app-custom-surveillance',

  templateUrl: './custom-surveillance.component.html',

  styleUrls: ['./custom-surveillance.component.css']

})

export class CustomSurveillanceComponent implements OnInit {

  loadingFront: boolean = false;

  loadingInside: boolean = false;

  iAttempt: number = 6;

  iTimeSpent: number = 10000;

  iAttemptFront: number = 0;

  iAttemptInside: number = 0;

  sanitizedUrl: SafeResourceUrl;

  private subscription?: Subscription;

  obj_Info: any;

  mdl_Request: FormGroup = this._fb.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    strUnitID: new FormControl(''),

    strUnitId: new FormControl(''),

    tiChannel: new FormControl(''),

    front: new FormControl(''),

    iDeviceCommand: new FormControl(''),

    front_iDeviceCommand: new FormControl(''),

    frontUrl: new FormControl(''),

    inside: new FormControl(''),

    inside_iDeviceCommand: new FormControl(''),

    insideUrl: new FormControl(''),


  })

  constructor(

    private _tooltip: NotificationService,

    private router: Router,

    private otherService: OtherService,

    private mapService: MapService,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _fb: FormBuilder,

    private httpClient: HttpClient,

    private sanitizer: DomSanitizer

  ) { }

  ngOnInit(): void {

    this.route.params.subscribe(params => {

      this.mdl_Request.patchValue({

        strUnitID: params['id'],

        strUnitId: params['id'],

      })

    })

    this.getInfo();

  }

  ngOnDestroy() {

    this.subscription?.unsubscribe();

  }

  async getInfo() {

    this.otherService.Showspinner();

    const resp = await axios.post(`GetCar?strUnitID=${this.mdl_Request.value.strUnitID}`, this.mdl_Request.value);

    this.otherService.nonespinner();

    let res = resp.data;

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12q1dss1110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.obj_Info = res;

    this.checkOut_Streaming(0, true);

    this.checkOut_Streaming(1, true);


  }

  async checkOut_Streaming(channel, init: boolean = false) {

    let model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.mdl_Request.get('strUnitID')?.value,

    }

    this.otherService.Showspinner();

    const resp = await axios.post(`Dashcam_CheckOnlineFull`, this.otherService.stringNumberToNumber(model));

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12q1dsxss1110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    if (res.Online) {

      if (channel == 0 && res.Ch1 == 1) {

        // if (!this.mdl_Request.get('front')?.value) {

        this.mdl_Request.patchValue({

          frontUrl: res.strCh1FLVURL,

          front: true

        })

        // }

      }

      if (channel == 1 && res.Ch2 == 1) {

        // if (!this.mdl_Request.get('inside')?.value) {

        this.mdl_Request.patchValue({

          insideUrl: res.strCh2FLVURL,

          inside: true

        })

        // }

      }

      else {

        if (!init) {

          this.startStreaming(channel);

        }


      }

    }

    else {

      if (!init) {

        this.startStreaming(channel);

      }
    }

  }

  async startStreaming(channel: number) {

    this.otherService.Showspinner();

    let model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.mdl_Request.get('strUnitID').value,

      tiChannel: channel,

      ClientId: this.gurdService.decrypt(localStorage.getItem('clientId')!) || '',

      Token: this.gurdService.decrypt(localStorage.getItem('token')!) || '',

    }

    const resp = await axios.post(`Dashcam_SendCommand4VideoStream`, this.otherService.stringNumberToNumber(model));

    // const resp = await axios.post(`Dashcam_SendCommand4VideoStream`, this.otherService.stringNumberToNumber(this.mdl_Request.value));

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12q1dss1110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    // دوربین جلو

    if (channel == 0) {

      this.mdl_Request.patchValue({

        front_iDeviceCommand: res[0].iDeviceCommand

      })

      this.loadingFront = true;

      this.iAttemptFront = 0;

      this.gettingFrontUrl();

    }

    // دوربین کابین

    if (channel == 1) {

      this.mdl_Request.patchValue({

        inside_iDeviceCommand: res[0].iDeviceCommand

      })

      this.loadingInside = true;

      this.iAttemptInside = 0;

      this.gettingInsideUrl();

    }

  }

  async selectRadio(channel: number) {

    if (channel == 0) {

      if (this.mdl_Request.get('front')?.value) {

        this.mdl_Request.patchValue({

          tiChannel: 0

        })

        // this.startStreaming(channel)

        this.checkOut_Streaming(channel)

      }

      else {

        this.mdl_Request.patchValue({

          tiChannel: '',

          frontUrl: '',

          iDeviceCommand: this.mdl_Request.get('front_iDeviceCommand')?.value

        })

        this.loadingFront = false;

        this.stopStreaming();

      }

    }

    else {

      if (this.mdl_Request.get('inside')?.value) {

        this.mdl_Request.patchValue({

          tiChannel: 1

        })

        // this.startStreaming(channel)

        this.checkOut_Streaming(channel)

      }

      else {

        this.mdl_Request.patchValue({

          tiChannel: '',

          insideUrl: '',

          iDeviceCommand: this.mdl_Request.get('inside_iDeviceCommand')?.value

        })

        this.loadingInside = false;

        this.stopStreaming();


      }

    }

  }

  async gettingFrontUrl() {

    let model = this.mdl_Request.value;

    model.iDeviceCommand = model.front_iDeviceCommand;

    const resp = await axios.post(`Dashcam_GetLiveStreamURL`, this.otherService.stringNumberToNumber(model));

    let res = JSON.parse(resp.data);

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12streaming1110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    if (this.iAttemptFront >= this.iAttempt && !this.mdl_Request.get('frontUrl')?.value) {

      this.subscription?.unsubscribe();

      this.loadingFront = false;

      this.mdl_Request.patchValue({

        front: false

      })


      return this._tooltip.showError('پاسخی از دوربین دریافت نشد!')

    }

    if (res?.strHLSURL && res.strHLSURL != '') {

      this.subscription?.unsubscribe();

      this.loadingFront = false;

      this.mdl_Request.patchValue({

        // frontUrl: 'http://193.5.44.229:8080/live/0/864993060617231.m3u8'

        frontUrl: res?.strHLSURL

      })

    }

    if (res?.strFLVURL && res.strFLVURL != '') {

      this.subscription?.unsubscribe();

      this.loadingFront = false;

      this.mdl_Request.patchValue({

        // frontUrl: 'http://193.5.44.229:8080/live/0/864993060617231.m3u8'

        frontUrl: res?.strFLVURL

      })

    }

    if (!res?.strHLSURL) {

      this.subscription?.unsubscribe();

      this.subscription = timer(this.iTimeSpent).subscribe(() => {

        this.gettingFrontUrl();

        this.iAttemptFront++;

      })

    }

  }

  async gettingInsideUrl() {

    let model = this.mdl_Request.value;

    model.iDeviceCommand = model.inside_iDeviceCommand;

    const resp = await axios.post(`Dashcam_GetLiveStreamURL`, this.otherService.stringNumberToNumber(model));

    let res = JSON.parse(resp.data);

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12streaming1110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    if (this.iAttemptInside >= this.iAttempt && !this.mdl_Request.get('insideUrl')?.value) {

      this.subscription?.unsubscribe();

      this.loadingInside = false;

      this.mdl_Request.patchValue({

        inside: false

      })


      return this._tooltip.showError('پاسخی از دوربین دریافت نشد!')

    }

    if (res?.strFLVURL && res.strFLVURL != '') {

      this.subscription?.unsubscribe();

      this.loadingInside = false;

      this.mdl_Request.patchValue({

        // insideUrl: 'http://193.5.44.229:8080/live/0/864993060617231.m3u8'

        insideUrl: res?.strFLVURL

      })

    }

    if (res?.strHLSURL && res.strHLSURL != '') {

      this.subscription?.unsubscribe();

      this.loadingInside = false;

      this.mdl_Request.patchValue({

        // insideUrl: 'http://193.5.44.229:8080/live/0/864993060617231.m3u8'

        insideUrl: res?.strHLSURL

      })

    }

    if (!res?.strHLSURL) {

      this.subscription?.unsubscribe();

      this.subscription = timer(this.iTimeSpent).subscribe(() => {

        this.gettingInsideUrl();

        this.iAttemptInside++;

      })

    }

  }

  async stopStreaming() {

    this.subscription?.unsubscribe();

    this.otherService.Showspinner();

    let model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.mdl_Request.get('strUnitID').value,

      tiChannel: this.mdl_Request.get('front')?.value ? 0 : 1

    }

    const resp = await axios.post(`Dashcam_CancelVideoStream`, this.otherService.stringNumberToNumber(model));

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12q1dss1110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    else {

      this.mdl_Request.patchValue({

        front: false,

        inside: false,

      })

    }

  }

  getModel(channel: 0 | 1) {

    this.mdl_Request.patchValue({

      strUnitId: this.mdl_Request.get('strUnitID')?.value + `-${channel}`

    })

    return this.mdl_Request.value;

  }


}
